const CAROUSEL_ITEMS = [
  {
    title: '国产古装剧巅峰合集',
    desc: '从《庆余年》到《长相思》，精选近两年口碑最好的国产古装大剧，全集一次性免费在线观看。精美的服化道与扎实的剧本，带你领略国风美学盛宴。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20themed%20visual%20with%20warm%20golden%20coral%20color%20palette%2C%20elegant%20abstract%20composition%20evoking%20storytelling%20and%20entertainment%2C%20soft%20dramatic%20lighting%20with%20rich%20textures%2C%20artistic%20film%20aesthetic%2C%20no%20text%20or%20logos&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '2024 韩剧必看清单',
    desc: '《眼泪女王》领衔年度韩剧高分榜，豪门虐恋、悬疑推理、治愈喜剧一应俱全。韩剧全集在线秒播，高清画质沉浸式追剧体验。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20drama%20themed%20visual%20with%20soft%20rose%20gold%20and%20warm%20amber%20tones%2C%20sophisticated%20abstract%20composition%20hinting%20at%20romance%20and%20melodrama%2C%20luxurious%20cinematic%20lighting%2C%20no%20text%20or%20logos%2C%20emotional%20atmospheric%20quality&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '悬疑烧脑剧迷专场',
    desc: '层层反转，烧脑不停！精选高能悬疑电视剧全集，从国产刑侦到韩式悬疑，每一部都让你欲罢不能，一口气追完整季。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20thriller%20themed%20visual%20with%20deep%20charcoal%20and%20warm%20coral%20accent%20tones%2C%20shadowy%20abstract%20composition%20evoking%20suspense%20and%20intrigue%2C%20dramatic%20cinematic%20lighting%20with%20rich%20contrast%2C%20no%20text%20or%20logos%2C%20tense%20atmospheric%20mood&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '甜宠爱情剧场连播',
    desc: '最甜的爱情故事都在这里！高糖预警，齁甜治愈。无论是古装虐恋还是现代甜宠，全集在线免费看，满足你的少女心。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20visual%20with%20warm%20peach%20and%20coral%20color%20palette%2C%20gentle%20abstract%20composition%20with%20floating%20particles%20and%20soft%20bokeh%2C%20dreamy%20cinematic%20lighting%2C%20no%20text%20or%20logos%2C%20sweet%20ethereal%20atmosphere&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '仙侠奇幻视觉盛宴',
    desc: '《与凤行》《狐妖小红娘月红篇》等热门仙侠剧全集，炫目特效搭配动人剧情，带你进入奇幻瑰丽的东方仙侠世界。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20visual%20with%20celestial%20golden%20and%20coral%20lighting%2C%20floating%20cloud%20and%20light%20beam%20abstract%20composition%2C%20mythical%20cinematic%20aesthetic%20with%20sparkling%20effects%2C%20no%20text%20or%20logos%2C%20heavenly%20dreamlike%20quality&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            精选专题策划，发现更多值得一看的好剧全集
          </p>
        </div>

        <div className="flex flex-col gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <div
              key={item.title}
              className="group flex flex-col md:flex-row gap-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all overflow-hidden cursor-pointer"
            >
              <div className="w-full md:w-72 shrink-0">
                <div className="relative h-48 md:h-full">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="flex-1 p-5 md:py-6 md:pr-6 flex flex-col justify-center">
                <h3 className="font-heading text-foreground-900 text-lg group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{item.desc}</p>
                <div className="mt-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-primary-500 font-medium cursor-pointer">
                    立即探索 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}